module.exports = __webpack_public_path__ + "static/media/college-stamp.086ff566.png";